import type { DeviceSettings } from "@tandemdiabetes/sugarmate-api-react-client"
import { useCallback } from "react"
import styles from "./DayStats.module.scss"
import { DayStatsSetting } from "./DayStatsSetting"
import { HideNotesHistory } from "./HideNotesHistory"

import { PageTemplate } from "src/components"
import {
  useFollowedUsers,
  usePolyglot,
} from "src/contexts"
import {
  useDebouncedUpdater,
  useUpdateDeviceSettings,
} from "src/hooks"

export function DayStats() {
  const polyglot = usePolyglot()

  const {
    currentUserId,
    currentDeviceSettings,
    currentFollow,
  } = useFollowedUsers()
  const deviceSettingsId = currentDeviceSettings.id
  const updatedAt = currentDeviceSettings.updated_at

  // TODO catch error and show toast
  const updateDeviceSettings = useUpdateDeviceSettings()
  const debouncedUpdateDeviceSettings = useDebouncedUpdater({ updater: updateDeviceSettings })

  const debouncedUpdateDeviceSettingsWithId = useCallback(
    (deviceSettings: Partial<DeviceSettings>) => debouncedUpdateDeviceSettings({
      id: deviceSettingsId,
      ...deviceSettings,
    }),
    [
      debouncedUpdateDeviceSettings,
      deviceSettingsId,
    ],
  )

  return (
    <PageTemplate
      user="follow"
      title={polyglot.t("components.page_header.pages.day_stats")}
      backRoutePath={currentFollow.is_self ? "/settings" : "/settings/$accountId"}
      backRouteParams={currentFollow.is_self ? {} : { accountId: currentUserId }}
    >
      <div className={styles.container}>
        <DayStatsSetting
          updatedAt={updatedAt}
          updateDeviceSettings={debouncedUpdateDeviceSettingsWithId}
        />
        {currentFollow.is_self && (
          <HideNotesHistory
            updatedAt={updatedAt}
            updateDeviceSettings={debouncedUpdateDeviceSettingsWithId}
          />
        )}
      </div>
    </PageTemplate>
  )
}
